import React from "react";
import PropTypes from "prop-types";
import PULSE_ICON from "@common/images/mc_pulse_black.svg";
import PULSE_ICON_ONFOCUS from "@common/images/mc_pulse_grey.svg";
import PULSE_ICON_INVALID from "@common/images/mc_pulse_invalid.svg";
import { Button } from "@learningblocks/shared-components/lib/Button";
import { Image } from "@learningblocks/shared-components/lib/Image";
import { MCStateContext } from "../../../..";
import { useTranslation } from "react-i18next";

import "./style.scss";

const pulseTime = new Date(0, 0, 0, 0, 0, 10);

const PULSE_ACTION = "PULSE";

const TRANSLATION_KEY = {
  PULSE: "Pulse.string",
  PULSE_ARIA: "PulseBotton.string",
};

export function PulseButton(props) {
  const { pulsing, running, balanced, isLidOpen } =
    React.useContext(MCStateContext);

  const { t } = useTranslation();

  const [IconSrc, setSrc] = React.useState(PULSE_ICON);

  const pulseRef = React.useRef(pulsing);

  React.useEffect(() => {
    if (!pulsing && pulseRef) {
      document.querySelector("#mc_pulse_button").blur();
    }
    pulseRef.current = pulsing;
  }, [pulsing]);

  const disabled = !(!running && balanced && !isLidOpen);

  const className =
    !pulsing && disabled
      ? `${props.className} mc_pulseButton--invalid`
      : `${props.className} mc_pulseButton`;

  const onClick = () => {
    if (!disabled) {
      props.setTimer(pulseTime.getTime());
      props.onRunCentrifuge(PULSE_ACTION);
    }
  };

  const onFocus = () => {
    setSrc(PULSE_ICON_ONFOCUS);
  };
  const onBlur = () => {
    setSrc(PULSE_ICON);
  };

  const renderIcon = () =>
    !pulsing && disabled ? (
      <Image className="mc_pulseButton_icon" src={PULSE_ICON_INVALID} alt="" />
    ) : (
      <Image className="mc_pulseButton_icon" src={IconSrc} alt="" />
    );

  return (
    <Button
      id="mc_pulse_button"
      className={className}
      onClick={onClick}
      onBlur={onBlur}
      onFocus={onFocus}
      aria-label={t(TRANSLATION_KEY.PULSE_ARIA)}
    >
      {renderIcon()}
      <span className="mc_pulseButton_text">{t(TRANSLATION_KEY.PULSE)}</span>
    </Button>
  );
}

PulseButton.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * callback function that accepts time to set timer in microcentrifuge
   */
  setTimer: PropTypes.func,
  /**
   * callback function to set microcentrifuge to running state
   */
  onRunCentrifuge: PropTypes.func,
};

PulseButton.defaultProps = {
  className: "",
};
